import React, {useEffect, useState} from 'react';
import {css, styled} from 'styled-components';
import {colors} from 'styles/colors';
import ScreenLayout from 'components/common/ScreenLayout';
import {getDevice} from 'utils/getDevice';
import DefaultText from 'components/common/DefaultText';
import {useRecoilValue} from 'recoil';
import {userInfoState} from 'utils/Atoms';
import moment from 'moment-timezone';
import {useLocation, useNavigate} from 'react-router-dom';
import ContainerHeader from 'components/common/ContainerHeader';
import {minmax} from 'utils/minmax';
import Footer from 'components/common/Footer';
import DefaultImageView from 'components/common/DefaultImageView';
import DefaultInput from 'components/common/DefaultInput';
import DefaultFormattedMessage from 'components/common/DefaultFormattedMessage';
import InfoCard from 'components/paymentManagement/InfoCard';
import CommonModal from 'components/common/CommonModal';
import {paymentTongPlace} from 'function/api';
import {ITongPlacePayment} from 'interfaces/interface';
import DefaultButton from 'components/common/DefaultButton';
import Pagination from 'components/common/Pagination';


/**
 * 결제 실패 현장 상세 페이지 컴포넌트
 * 특정 현장의 결제 정보 및 결제 내역을 조회하는 페이지입니다.
 * @returns {JSX.Element} 결제 실패 현장 상세 페이지 컴포넌트
 */
const PaymentFailureTongPlace = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const device = getDevice();

  const tongPlaceUUID = location?.state?.uuid || '';

  const userInfo = useRecoilValue(userInfoState);

  const [isLoading, setIsLoading] = useState(false);
  const [errorModal, setErrorModal] = useState({});

  const [infoData, setInfoData] = useState<ITongPlacePayment | null>(null);

  const [modal, setModal] = useState('');
  const [emailValue, setEmailValue] = useState('');

  const [paymentHistoryList, setPaymentHistoryList] =
    useState<any[]>([]);

  const [totalPage, setTotalPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  // todo 리스트페이지네이션
  // useEffect(() => {
  //   if (infoData) {
  //     const resTotalPage = convertTotalPage(infoData.count ?? 0, 10);
  //     setTotalPage(resTotalPage);
  //   }
  // }, [data]);

  useEffect(() => {
    tongPlaceUUID &&
      paymentTongPlace({
        userInfo,
        setIsLoading,
        setErrorModal,
        tongPlaceUUID,
      }).then((data: any) => {
        setInfoData(data);
      });
  }, [tongPlaceUUID]);

  useEffect(() => {
    const query = location.search;
    if (query.includes('isSuccess')) {
      if (query.includes('true')) {
        setModal('cardComplete');
      } else if (query.includes('false')) {
        setModal('cardFail');
      }
    }
  }, [location]);

  const modalData: {[key: string]: any} = {
    email: {
      title: 'modifyReceiptEmail',
      children: (
        <DefaultInput
          value={emailValue}
          setValue={e => setEmailValue(e)}
          wrapperStyle={{
            width: '100%',
            height: minmax(60),
            marginBottom: minmax(43),
          }}
        />
      ),
      firstButtonText: 'cancel',
      secondButtonText: 'toModify',
      firstButtonStyle: {
        backgroundColor: colors.borderGray,
      },
      secondButtonStyle: {
        backgroundColor: colors.primary2,
      },
      firstButtonClick: () => {
        setModal('');
        setEmailValue('이메일이메일');
      },
      secondButtonClick: () => {
        setModal('emailComplete');
      },
    },

    emailComplete: {
      title: 'emailSaved',
      detail: 'emailModified',
      firstButtonText: 'confirm',
      firstButtonStyle: {
        backgroundColor: colors.primary2,
      },
      firstButtonClick: () => {
        setModal('');
      },
    },
    cardComplete: {
      title: 'completeRegisterCardTitle',
      detail: 'completeRegisterCardDetail',
      firstButtonText: 'confirm',
      firstButtonStyle: {
        backgroundColor: colors.primary2,
      },
      firstButtonClick: () => {
        setModal('');
        navigate('/paymentManagement');
      },
    },
    noCard: {
      title: 'requestRegisterCardTitle',
      detail: 'requestRegisterCardDetail',
      firstButtonText: 'confirm',
      firstButtonStyle: {
        backgroundColor: colors.primary2,
      },
      firstButtonClick: () => {
        setModal('');
      },
    },
    cardFail: {
      title: 'failRegisterCardTitle',
      detail: 'failRegisterCardDetail',
      firstButtonText: 'confirm',
      firstButtonStyle: {
        backgroundColor: colors.primary2,
      },
      firstButtonClick: () => {
        setModal('');
      },
    },
    subscribePlan: {
      title: 'subscribePlan',
      children: (
        <DefaultInput
          value={emailValue}
          setValue={e => setEmailValue(e)}
          wrapperStyle={{
            width: '100%',
            height: minmax(60),
            marginBottom: minmax(43),
          }}
        />
      ),
      firstButtonText: 'cancel',
      secondButtonText: 'toModify',
      firstButtonStyle: {
        backgroundColor: colors.borderGray,
      },
      secondButtonStyle: {
        backgroundColor: colors.primary2,
      },
      firstButtonClick: () => {
        setModal('');
      },
      secondButtonClick: () => {
        setModal('emailComplete');
      },
    },
  };

  return (
    <ScreenLayout isLoading={isLoading} errorModal={errorModal}>
      {infoData && (
        <Container>
          {/* 서비스 준비중 모달 */}
          {/* <ServicePreparingInnerModal /> */}

          <ContainerHeader
            mainTitle="paymentManagement"
            subTitle="paymentFailureDetail"
          />

          <Main $device={device}>
            {/* 현재 결제 정보 */}
            <InfoCard
              infoData={infoData}
              setModal={setModal}
              setErrorModal={setErrorModal}
              setIsLoading={setIsLoading}
            />
            <HeaderContainer>
              <DefaultText text="paymentHistory" textStyle={HeaderTextStyle} />
              <DefaultButton
                text={'businessTripRequest'}
                buttonStyle={{
                  width: minmax(200),
                  height: minmax(60),
                  backgroundColor: '#387a47',
                }}
                textStyle={{
                  color: colors.white,
                  fontSize: minmax(20),
                }}
              />
            </HeaderContainer>
            <ResultArea>
              {/* 결제 내역 Header */}
              <ResultHeader>
                <DefaultText
                  text="paymentDate"
                  textStyle={{...ResultHeaderTextStyle, flex: 1}}
                />
                <DefaultText
                  text="usagePlan"
                  textStyle={{...ResultHeaderTextStyle, flex: 1.5}}
                />
                <DefaultText
                  text="paymentAmount"
                  textStyle={{...ResultHeaderTextStyle, flex: 1}}
                />
                <DefaultText
                  text="state"
                  textStyle={{...ResultHeaderTextStyle, flex: 1}}
                />
                {/* TODO: 권한 확인 필요 */}
                {/* {ablePermission && ( */}
                <>
                  <DefaultText
                    text="receipt"
                    textStyle={{...ResultHeaderTextStyle, flex: 1}}
                  />
                  <DefaultText
                    text="statement"
                    textStyle={{...ResultHeaderTextStyle, flex: 1}}
                  />
                </>
                {/* )} */}
              </ResultHeader>

              <ResultList>
                {/* 결제 내역 */}
                {paymentHistoryList?.length !== 0 ? (
                  paymentHistoryList?.map((item, index) => (
                    <ResultItem
                      key={index}
                      onClick={() => {
                        console.log('상세보기');
                      }}>
                      <DefaultText
                        text={moment(item.paymentDate)?.format('YYYY.MM.DD')}
                        textStyle={{...ResultItemStyle, flex: 1}}
                      />
                      <DefaultText
                        text={item.paymentPlan}
                        textStyle={{...ResultItemStyle, flex: 1.5}}
                      />

                      <DefaultFormattedMessage
                        id="priceFormat"
                        values={{
                          price:
                            item.finalPaymentAmount.toLocaleString('ko-KR'),
                        }}
                        style={{...ResultItemStyle, flex: 1}}
                      />
                      <DefaultText
                        text={item.state}
                        textStyle={{...ResultItemStyle, flex: 1}}
                      />
                      {/* TODO: 권한 확인 필요 */}
                      {/* {ablePermission && ( */}
                      <>
                        <ResultItemImageStyle
                          style={{flex: 1}}
                          // onClick={() => setModal('manager')} // TODO! 영수증
                          href={item.receipt}
                          download="receipt.pdf">
                          <DefaultText
                            text="download"
                            textStyle={{
                              ...ResultItemStyle,
                              textDecoration: 'underline',
                            }}
                          />
                          <DefaultImageView
                            source="images/common/download_red.png"
                            style={{width: minmax(36)}}
                          />
                        </ResultItemImageStyle>
                        <ResultItemImageStyle
                          style={{flex: 1}}
                          // onClick={() => setModal('manager')} // TODO! 거래명세서
                          href={item.statement}
                          download="statement.pdf">
                          <DefaultText
                            text="download"
                            textStyle={{
                              ...ResultItemStyle,
                              textDecoration: 'underline',
                            }}
                          />
                          <DefaultImageView
                            source="images/common/download_red.png"
                            style={{width: minmax(36)}}
                          />
                        </ResultItemImageStyle>
                      </>
                      {/* )} */}
                    </ResultItem>
                  ))
                ) : (
                  // 결제 내역 없음
                  <NoPaymentInfoContainer>
                    <DefaultText
                      text="noDataMsgPaymentHistory2"
                      textStyle={{
                        color: colors.graniteGray,
                        textAlign: 'center',
                        margin: `${minmax(12)} 0`,
                        whiteSpace: 'pre',
                        fontSize: minmax(20),
                        lineHeight: 1.8,
                      }}
                      formattedMessageStyle={{fontWeight: 'bold'}}
                    />
                    <DefaultButton
                      text={'installAndBusinessTripRequest'}
                      buttonStyle={{
                        width: minmax(314),
                        height: minmax(60),
                        backgroundColor: '#387a47',
                      }}
                      textStyle={{
                        color: colors.white,
                        fontSize: minmax(20),
                      }}
                    />
                  </NoPaymentInfoContainer>
                )}
              </ResultList>
              {paymentHistoryList.length !== 0 ? (
                <Pagination
                  totalPage={totalPage}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              ) : null}
            </ResultArea>
          </Main>
        </Container>
      )}

      <Footer isMain />

      {modal !== '' && (
        <CommonModal
          title={modalData[modal].title}
          detail={modalData[modal].detail}
          firstButtonText={modalData[modal].firstButtonText}
          firstButtonStyle={modalData[modal].firstButtonStyle}
          secondButtonText={modalData[modal].secondButtonText}
          secondButtonStyle={modalData[modal].secondButtonStyle}
          firstButtonClick={modalData[modal].firstButtonClick}
          secondButtonClick={modalData[modal].secondButtonClick}
          closeModal={() => setModal('')}>
          {modalData[modal].children}
        </CommonModal>
      )}
    </ScreenLayout>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
`;

const Main = styled.div<{$device?: string}>`
  width: 90%;
  padding: ${minmax(20)} 0 0 2%;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${(props: any) =>
    props.$device !== 'pc' &&
    css`
      width: 100%;
    `}
`;

const HeaderTextStyle = {
  width: 'fit-content',
  fontWeight: 500,
  borderBottom: `3px solid ${colors.primary}`,
  alignSelf: 'center',
};

const ResultArea = styled.div`
  width: 100%;
  margin-bottom: ${minmax(33)};
`;

const ResultHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: ${minmax(52)};
  background-color: #f7f7f7;
`;

const ResultHeaderTextStyle: React.CSSProperties = {
  textAlign: 'center',
  color: '#585858',
};

const ResultItemStyle: React.CSSProperties = {
  textAlign: 'center',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  wordBreak: 'break-all',
};

const ResultList = styled.ul`
  border-bottom: 1px solid ${colors.darkGray};
  margin-bottom: ${minmax(30)};
`;

const ResultItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: ${minmax(52)};
  border-bottom: 1px solid ${colors.lightGrey};
  position: relative;
  &:last-child {
    border-bottom: none;
  }
`;

const ResultItemImageStyle = styled.a`
  display: flex;
  flex-direction: row;
  column-gap: ${minmax(4)};
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const NoPaymentInfoContainer = styled.div`
  height: ${minmax(260)};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  row-gap: ${minmax(28)};
`;

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${minmax(24)};
`;

export default PaymentFailureTongPlace;

